<!--
  - Copyright (c) 2023-2024. Haodong JU
  -->

<template>
  <div>
    <page-header>
      {{ $t('Rules') }}
      <template #action>
        <primary-button
          @click="editingRule=null;showDialog=true"
          text="AddRule"
          icon="mdi-plus"
        />
      </template>
    </page-header>
    <loading-provider
      :loading="loading"
      class="mt-4"
    >
      <div style="display: grid;grid-template-columns: 1fr;grid-gap: 4px">
        <v-card
          @click="editRule(r)"
          elevation="0"
          v-for="r in ruleList"
          :key="r.id"
          class="px-4 py-3 pt-4
"
        >
          <div class="d-flex align-center">
            <div class="text-body-1 font-weight-black">
              <template v-if="r.minPersonCount === r.maxPersonCount">
                {{ r.minPersonCount }}{{ $t('TableForPerson') }}
              </template>
              <template v-else>
                {{ r.minPersonCount }}-{{ r.maxPersonCount }}{{ $t('TableForPerson') }}
              </template>
            </div>
            <v-spacer />
            <span class="text-caption"> <v-icon small>mdi-menu</v-icon>  {{ r.priority }}</span>

            <v-btn
              @click.stop="deleteRule(r)"
              class="ml-2"
              small
              elevation="0"
              color="grey lighten-4"
            >
              {{ $t('delete') }}
            </v-btn>
          </div>
          <div class="d-flex mt-1 align-center">
            <div class="text-body-1 mr-2">
              {{ $t('AppliedTo') }}
            </div>
            <v-card
              elevation="0"
              color="grey lighten-4"
              class="mr-2 pa-1 px-2"
              v-for="tr in groupTableRequirements(r.tableRequirements) "
              :key="tr.seat"
            >
              <template>
                {{ tr.count }}&times;
              </template>
              <span class="text-body-1 font-weight-black">{{ tr.seat }}{{ $t('PersonsAllowedOnTable') }}</span>
            </v-card>
          </div>
          <div>
            {{ $t('LengthOfMeal') }} {{ r.estimateDiningTime * 15 }}min<span v-if="r.cleaningTime>0">(+{{
              r.cleaningTime * 15
            }}min)</span>
          </div>
        </v-card>
      </div>
    </loading-provider>
    <v-dialog
      v-model="showDialog"
      max-width="500"
    >
      <base-form
        :show="showDialog"
        :editing-object="editingRule"
        @submit="save"
        :schema="schemas"
        @close="showDialog=false"
      >
        {{ $t('CreateEditRules') }}
      </base-form>
    </v-dialog>
  </div>
</template>

<script>
import PageHeader from '@/views/widget/typography/PageHeader.vue'
import LoadingProvider from '@/views/widget/LoadingProvider.vue'
import { deletePersonRule, getPersonRules, savePersonRule } from '@/model/dataLayer/service/reservation/personRules'
import PrimaryButton from '@/views/AadenPages/components/PrimaryButton.vue'
import BaseForm from '@/model/baseForm/BaseForm/BaseForm.vue'
import TableRequirementEditor from '@/views/AadenPages/settings/reserveSetting/tableRule/TableRequirementEditor.vue'
import { groupBy } from 'lodash-es'
import { sureToDelete } from '@/model/utils/utils'

export default {
  name: 'TableRules',
  components: {
    BaseForm,
    PrimaryButton,
    LoadingProvider,
    PageHeader
  },
  data: () => {
    return ({
      loading: false,
      showDialog: null,
      editingRule: null,
      ruleList: []
    })
  },
  computed: {
    schemas () {
      return [
        {
          key: 'estimateDiningTime',
          hint: 'estimateDiningTimeHint',
          default: 6
        },
        { key: 'cleaningTime', hint: 'cleaningTimeHint' },
        { key: 'minPersonCount' },
        { key: 'maxPersonCount' },
        {
          key: 'tableRequirements',
          component: TableRequirementEditor,
          hint: '需要的桌子情况，例如4-5个人应该坐四人桌，那么该规则的桌子要求就是需要一张四人桌'
        },
        { key: 'priority', hint: '规则冲突时，优先级数字小的会被优先使用' }
      ]
    }
  },
  mounted () {
    this.reloadData()
  },
  methods: {
    editRule (rule) {
      this.editingRule = rule
      this.showDialog = true
    },
    async deleteRule (item) {
      await sureToDelete(async () => {
        await deletePersonRule(item.id)
        await this.reloadData()
      })
    },
    async save (item) {
      await savePersonRule(item)
      this.showDialog = false
      await this.reloadData()
    },
    groupTableRequirements (tableRequirements) {
      return Object.entries(groupBy(tableRequirements, 'seatCount')).map(([seat, count]) => ({
        seat,
        count: count.length
      }))
    },

    async reloadData () {
      this.loading = true
      this.ruleList = await getPersonRules()
      console.log(this.ruleList)

      this.loading = false
    }
  }
}
</script>

<style scoped>

</style>
